'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateAsLocalISOString = require('./dateAsLocalISOString');

var _dateAsLocalISOString2 = _interopRequireDefault(_dateAsLocalISOString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (date) {
    return (0, _dateAsLocalISOString2.default)(date).slice(11, 19);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/dateToTimeString.js
// module id = 18
// module chunks = 0